export default {
    firstToCreate: 'Bądź pierwszą osobą, która utworzy wątek na tym forum',
    firstToPostInCategory: 'Bądź pierwszą osobą, która doda post w tej kategorii',
    firstToRespondToTopic: 'Bądź pierwszą osobą, która odpowie na ten temat!',
    createNewThread: 'Utwórz nowy wątek',
    thread: 'wątek',
    viewThread: 'Zobacz wątek',
    replies: 'Odpowiedzi',
    noReplies: 'Brak odpowiedzi',
    reply: 'odpowiedz',
    _reply: 'Odpowiedz',
    ReplyTo: 'Odpowiedz na',
    replyToThisQuestion: 'Odpowiedz na to pytanie',
    onceRepliedModeratorMayRespond: 'Po dodaniu odpowiedzi moderator forum może na nią odpowiedzieć',
    onceRepliedCanViewResponses: 'Po dodaniu odpowiedzi możesz zobaczyć odpowiedzi innych uczestników',
    loadingResponses: 'Ładowanie odpowiedzi',
    hideXReplies: 'Ukryj {count} odpowiedzi',
    showXReplies: 'Pokaż {count} odpowiedzi',
    hideMostRecentReplies: 'Ukryj najnowsze odpowiedzi',
    showMostRecentReplies: 'Pokaż najnowsze odpowiedzi',
    post: 'Post',
    message: 'Wiadomość',
    typeMessage: 'Wpisz wiadomość',
    addPost: 'Dodaj post',
    addMessage: 'Dodaj wiadomość',
    editPost: 'Edytuj post',
    editPostWithMedia: 'Edytuj post z multimediami',
    createPostWithMedia: 'Utwórz post z multimediami',
    deleteMessage: 'Usuń wiadomość',
    deleteMessageConfirm: 'Czy na pewno chcesz usunąć tę wiadomość?',
    pinPost: 'Przypnij post',
    media: 'Media',
    uploadMedia: 'Prześlij media',
    categories: 'kategorie',
    goBack: 'Wróć',
    goBackPrevious: 'Wróć do poprzedniej strony',
    goBackToCategory: 'Wróć do kategorii {name}',
    loadingLatestThreads: 'Ładowanie najnowszych wątków',
    loadingDiscussionForum: 'Ładowanie forum dyskusyjnego',
    dontShowAgainForTask: 'Nie pokazuj ponownie dla tego zadania',
    title: 'Tytuł',
    beTheFirst: 'Bądź pierwszym, który odpowie na ten wątek'
};
